import styled from '@emotion/styled';
import { Typography } from '@mui/material';

const TruncatedTypographicText = styled(Typography)`
  white-space: pre-wrap;
  word-break: break-all;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export default TruncatedTypographicText;
